import { useEffect, useState } from "react";
import seed from "../data/menu-seed.json";
import { fetchMenu } from "../Services/Menu/fetchMenu";

const CACHE_KEY = "pp_menu_cache_v1";

const leerCache = () => {
  try {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
    return cache?.secciones ? cache : null;
  } catch {
    return null;
  }
};

// Menú de la página pública.
// 1. Pinta al instante lo último que se vio (localStorage) o, si es la primera visita, el menú base del repo.
// 2. En segundo plano pide el menú a la Lambda (DynamoDB) y, si llega, lo pinta y lo guarda.
// Así la página nunca se queda en blanco aunque la API falle.
export const useMenuData = () => {
  const [menu, setMenu] = useState(() => leerCache() || seed);
  const [fuente, setFuente] = useState(() => (leerCache() ? "cache" : "seed"));

  useEffect(() => {
    if (!process.env.REACT_APP_BASE_URL) return;

    let cancelado = false;
    fetchMenu().then((response) => {
      if (cancelado || response.statusCode !== 200 || !Array.isArray(response.secciones)) return;
      const nuevo = {
        secciones: response.secciones,
        productos: response.productos || [],
        promos: response.promos || [],
      };
      setMenu(nuevo);
      setFuente("api");
      try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(nuevo));
      } catch { }
    });

    return () => {
      cancelado = true;
    };
  }, []);

  return { ...menu, fuente };
};
